export type OpenHours = {
  dow: string;
};

export function sortByCustomDaysOrder<T extends OpenHours>(displayHours: T[]): T[] {
  const daysOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  return [...displayHours].sort(
    (a, b) => daysOrder.indexOf(String(a.dow)) - daysOrder.indexOf(String(b.dow)),
  );
}
